<template>
  <div class="form-input">
    <input
      :type="inputType"
      :id="inputID"
      :class="inputStyle"
      :value="inputValue"
      v-model="internalValue"
      @click.stop
    >
    <label :for="labelFor">
      <span>
        {{ labelValue }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    inputID: String,
    inputStyle: String,
    inputType: String,
    inputValue: String,
    labelFor: String,
    labelValue: String,
    placeholderText: String,
    checked: Array,
  },
  model: {
    prop: 'checked',
  },
  data() {
    return {

    };
  },
  computed: {
    internalValue: {
      get() { return this.checked; },
      set(v) { this.$emit('input', v); },
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" src="../scss/form-input.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SelectInput.vue